import { connect } from 'react-redux';

import flatten from 'lodash/flatten';
import { trackActions, RootState, Dispatch } from '../../api';
import TracksList, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/TracksList';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  ({
    tracks: {
      entries,
      likedTracks: { data, pagination },
      isFetchingLikedTracks,
    },
  }) => ({
    tracks: flatten(Object.values(data || {})).map((id: number) => entries[id]),
    isFetching: isFetchingLikedTracks,
    currentPage: pagination ? pagination.currentPage : 1,
    lastPageReached: pagination
      ? pagination.currentPage >= pagination.lastPage
      : false,
    playlistType: 'chart',
  }),
  (dispatch: Dispatch) => ({
    fetchTracks: ({ id, page = 1 }) => {
      if (id !== undefined) {
        dispatch(trackActions.fetchLikedTracks(id, page));
      }
    },
  }),
)(TracksList);
